export const FormMode = {
    ViewMode: 0,
    NewMode: 1,
    EditMode: 2,
    None: 3
};

export const GenderList = [
    {
        "id": 0,
        "label": "Male"
    },
    {
        "id": 1,
        "label": "Female"
    }
]

export const CommonUrls = {
    UserLogin: 'user-login',
    UserLoginSession: 'user-login-session',
    Company: 'company/<code>/',
    GetReligions: 'religions/',
    ServiceTypes: 'service-types/',
    Document: 'document',
    GetReminderData: 'reminders',
    NurseSeach: 'nurses?search=<search-text>&search-only-no-service=<search-only-no-service>',
    Nurse: 'nurse',
    Patient: 'patient',
    PatientSearch: 'patients',
    PatientComplete: 'patient/complete',
    PatientNurseChange: 'patient/nurse-change',
    PatientRenewService: 'patient/renew-service',
    ServicePayment: 'patient/<service_id>/service-payment',
    PatientServicePayment: 'patient-service-payment',
    NurseSalaryPaySearch: 'nurse/salary-payment-search',
    NursePendingSalaryPay: 'nurse/pending-salary-payment',
    NurseSalaryPayment: 'nurse/salary-payment',
    NurseAdvancePaySearch: 'nurse/advance-payment-search',
    NurseAdvanceReturnPaySearch: 'nurse/advance-return-search',
    NurseAdvancePayment: 'nurse/advance-payment',
    NurseAdvanceReturnPayment: 'nurse/advance-payment-return',
    NurseVacationTracker: 'nurse/vacation-tracker',
    NurseServiceBookingSearch: 'nurse/service-booking-search',
    NurseServiceBooking: 'nurse/service-booking',
    USysEmployeeSearch: 'usys-employees?search-text=',
    USysEmployee: 'usys-employee',
    USysEmployeeDocument: 'usys-employee-document',
    UserChangePassword: 'user/change-password'
}

export const ConstantValues = {
    DefaultDateValue: new Date(2000, 0, 1),
    DefaultContactAddressId: 1
}

export const ServiceStatus = {
    Active: 1,
    Completed: 2
}

export const ServiceNurseStatus = {
    Active: 1,
    Completed: 2
}

export const CurrentActiveServicePage = {
    None: 0,
    ViewPage: 1,
    NewPage: 2,
    EditPage: 3,
    ChangeNursePage: 4
}

export const EmployeeStatus = {
    Active: 1,
    Terminated: 2
}

export const Districts = ['Kasaragod', 'Kannur', 'Wayanad', 'Kozhikode', 'Malappuram', 'Palakkad', 'Thrissur', 'Ernakulam',
    'Idukki', 'Kottayam', 'Alappuzha', 'Pathanamthitta',
    'Kollam', 'Thiruvananthapuram'].sort();


export const USysObjects = {
    Employees: 1,
    Nurses: 2,
    NurseAdvancePayments: 3,
    NurseSalaryPayments: 4,
    NurseVacationTrackers: 5,
    PatientServiceBookings: 6,
    PatientServices: 7,
    PatientServicePayments: 8,
    DayBooks: 9
}